import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Uniform pill-tab styling used across all navigation tabs in the app.
export const tabClass = (active) =>
  `rounded-full px-4 py-2 text-sm font-medium transition-colors border ${
    active
      ? "bg-emerald-900 text-white border-emerald-900"
      : "bg-emerald-50 text-emerald-800 border-emerald-100 hover:bg-emerald-100"
  }`;
